module.exports = __webpack_public_path__ + "img/logo.952a66be.png";